import { matchPath } from 'react-router-dom';

import { combineEpics } from 'redux-observable';
import { EMPTY, Observable } from 'rxjs';
import { filter, switchMap, withLatestFrom } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import { selectSelectedProvider } from 'rdx/account';
import { GlobalAppActions, routeChangeAction } from 'rdx/actions';
import { applicationRoutes } from 'rdx/analytics/applicationRoutes';
import { MixpanelExtraParams } from 'rdx/analytics/types';
import { getMixpanelExtraParams } from 'rdx/analytics/utils';
import { AppServices } from 'rdx/middleware';
import { GlobalAppState } from 'rdx/state';
import { forEachEnumKeyVal } from 'utils/enum';

enum MixpanelEventType {
  NAVIGATION_PATH_CHANGE = 'navigation_path_change',
}

const trackMixpanelEventsOnRouteChangeEpic = (
  action$: Observable<GlobalAppActions>,
  state$: Observable<GlobalAppState>,
  { mixpanelService }: AppServices,
): Observable<GlobalAppActions> => {
  return action$.pipe(
    filter(isActionOf(routeChangeAction)),
    withLatestFrom(state$),
    switchMap(([action, state]) => {
      const { pathname, search } = action.payload.location;

      if (pathname) {
        forEachEnumKeyVal(applicationRoutes, (moduleName, moduleRoutes) => {
          moduleRoutes.forEach((path) => {
            const pathToMatch = `${moduleName ? `/` : ``}${moduleName}${path}`;
            const match = matchPath(pathname, {
              path: pathToMatch,
              exact: true,
              strict: true,
            });
            if (match) {
              const providerId = selectSelectedProvider(state)?.providerId;
              const extraParams: MixpanelExtraParams = getMixpanelExtraParams(moduleName, search);
              mixpanelService.trackProviderEvent(MixpanelEventType.NAVIGATION_PATH_CHANGE, {
                providerId,
                path: match.path,
                ...match.params,
                ...extraParams,
              });
            }
          });
        });
      }

      return EMPTY;
    }),
  );
};

export const analyticEpic = combineEpics(trackMixpanelEventsOnRouteChangeEpic);
